import { Component, inject } from '@angular/core';
import { SoftwareSpecificSearchService } from '../../software-specific-search.service';

@Component({
    selector: 'app-webshop-popup',
    templateUrl: './webshop-popup.component.html',
    styleUrls: ['../soft-ware-request-form-page.component.scss'],
    standalone: false
})
export class WebshopPopupComponent {
  public service = inject(SoftwareSpecificSearchService);

}
